import * as R from 'ramda'
// @ts-ignore
import { createAction } from 'redux-actions'
import { dispatch, RootState } from '$setup/redux'
import { AD } from '$logic/ads/types'

interface AdsStorageState {
  chatList: AD[]
}

const initialState: AdsStorageState = {
  chatList: [],
}

// reducer
const SET_ADS_DATA = 'SET_ADS_DATA'
const setAdsData = createAction(SET_ADS_DATA)
const dispatchSetAdsData = (data: Partial<AdsStorageState>) =>
  dispatch(setAdsData(data))

// reducers
const reducers = {
  [SET_ADS_DATA]: R.mergeRight,
}

export const adsStorage = {
  setAdsStorage: (ads: { chatList: AD[] }) => dispatchSetAdsData(ads),
}

export const adsReducer = (
  state = initialState,
  {
    type,
    payload,
  }: { type: keyof typeof reducers; payload: Partial<AdsStorageState> },
) => (reducers[type] ? reducers[type](state, payload) : state)

export const chatListAdsViewer = (root: RootState): AD[] =>
  root.main.ads.chatList
